"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listSportsbookMarkets = listSportsbookMarkets;
const genericResponse_1 = require("../../types/genericResponse");
async function listSportsbookMarkets(params) {
    if (this.controllerDefaults === null && this.userContext === undefined) {
        throw { returnCode: genericResponse_1.ReturnCode.DefaultsNotLoaded };
    }
    const request = {
        header: this.header,
        integrationPartnerId: this.userContext !== null
            ? this.userContext?.integrationPartnerId
            : this.controllerDefaults.integrationPartnerId,
        language: this.userContext?.language || this.controllerDefaults.language,
        ...params,
    };
    return (await this.sendRequest('listSportsbookMarkets.ashx', request));
}
